import { useEffect, useState } from 'react';
import { useRoutes } from 'react-router-dom';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { Box } from '@chakra-ui/react';
import LoadingSpinner from 'components/core/LoadingSpinner';
import LoginRoutes from './LoginRoutes';
import MainRoutes from './MainRoutes';

export default function ThemeRoutes() {
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const auth = getAuth();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async user => {
      setIsAuthenticated(Boolean(user));
    });

    return () => unsubscribe();
  }, [auth]);

  const loadingRoutes = {
    path: '*',
    element: (
      <Box display="flex" justifyContent="center" mt={12}>
        <LoadingSpinner />
      </Box>
    )
  };

  return useRoutes([isAuthenticated === null ? loadingRoutes : isAuthenticated ? MainRoutes : LoginRoutes]);
}
